import React from "react";

export default function Loader() {
  return (
    <div className="loader-page">
      <div className="loader-content">

        <img
          src="/assets/Seanfh NEW logo (modified).png"
          alt="Sean FH Logo"
          className="loader-logo-img"
        />
        <p className="loader-sub"></p>

        <div className="flight-line">
          <span></span>
        </div>

      </div>
    </div>
  );
}
